import { useEffect, useState, useCallback } from "react";
import { RefreshCw } from "lucide-react";
import { api } from "@/lib/api";

export function useBotCheck() {
  const [ch, setCh] = useState(null);
  const [answer, setAnswer] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const refresh = useCallback(async () => {
    setAnswer("");
    try {
      const { data } = await api.get("/challenge");
      setCh(data);
    } catch (e) {
      setCh(null);
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  return {
    question: ch?.question,
    token: ch?.token,
    answer,
    setAnswer,
    honeypot,
    setHoneypot,
    refresh,
    payload: () => ({ challenge_token: ch?.token || "", challenge_answer: answer, website: honeypot }),
  };
}

export default function BotCheck({ state, testPrefix = "form", theme = "dark" }) {
  const inputCls = theme === "dark" ? "lux-input" : "adm-input";
  return (
    <div className="lux-panel p-4" data-testid={`${testPrefix}-botcheck`}>
      <div className="flex items-center justify-between gap-3">
        <label htmlFor={`${testPrefix}-botcheck-input`} className="lux-label">
          Quick human check
        </label>
        <button
          type="button"
          onClick={state.refresh}
          className="inline-flex items-center gap-1 text-xs text-lux-silver hover:text-lux-silverBright"
          data-testid={`${testPrefix}-botcheck-refresh`}
        >
          <RefreshCw className="h-3.5 w-3.5" aria-hidden="true" /> New question
        </button>
      </div>
      <p className="mt-2 text-sm text-lux-text" data-testid={`${testPrefix}-botcheck-question`}>
        {state.question || "Loading..."}
      </p>
      <input
        id={`${testPrefix}-botcheck-input`}
        inputMode="numeric"
        autoComplete="off"
        className={`${inputCls} mt-2 max-w-[140px]`}
        placeholder="Number"
        value={state.answer}
        onChange={(e) => state.setAnswer(e.target.value.replace(/[^0-9]/g, ""))}
        data-testid={`${testPrefix}-botcheck-input`}
        aria-describedby={`${testPrefix}-botcheck-help`}
      />
      <p id={`${testPrefix}-botcheck-help`} className="mt-2 text-xs text-lux-muted">
        Answer with digits. This keeps automated spam out without third-party scripts.
      </p>
      <div className="sr-honeypot" aria-hidden="true">
        <label htmlFor={`${testPrefix}-website`}>Leave this field empty</label>
        <input
          id={`${testPrefix}-website`}
          tabIndex={-1}
          autoComplete="off"
          value={state.honeypot}
          onChange={(e) => state.setHoneypot(e.target.value)}
          data-testid={`${testPrefix}-honeypot-input`}
        />
      </div>
    </div>
  );
}
